import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { processImportesDatosEconomicos,
  processGastosDatosEconomicos,
  formatImportesDatosEconomicos,
  formatGastosDatosEconomicos,
  formatInstanciaLetra,
  processInstanciaLetra,
  processInstanciaLetraResponse,
} from './utils';

const IMPORTES_URL = `${API_CONFIG.API}/node/volume`;
const GASTOS_URL = `${API_CONFIG.API}/node/expenses`;
const LETRAS_URL = `${API_CONFIG.API}/node/instancia_letra`;

const OPERATION_URL = `${API_CONFIG.API}/node/operation?include=volume&filter[uuid][value]=`;
const OPERATION_GASTOS_URL = `${API_CONFIG.API}/node/operation?include=expenses&filter[uuid][value]=`;
const OPERATION_LETRAS_URL = `${API_CONFIG.API}/node/operation?include=letras_operation&filter[uuid][value]=`;

export default {
  getVolumesByOperation(idOp) {
    return base.http().get(`${OPERATION_URL}${idOp}`)
       .then((res) => {
         if (res.data.included) {
           return processImportesDatosEconomicos(res.data.included[0]);
         }
         return res.data.data;
       });
  },
  getGastosByOperation(idOp) {
    return base.http().get(`${OPERATION_GASTOS_URL}${idOp}`)
       .then((res) => {
         if (res.data.included) {
           return processGastosDatosEconomicos(res.data.included[0]);
         }
         return res.data.data;
       });
  },
  getLetrasByOperation(idOp) {
    return base.http().get(`${OPERATION_LETRAS_URL}${idOp}`)
      .then((res) => {
        const list = [];
        if (Array.isArray(res.data.included)) {
          res.data.included.forEach((instancia) => {
            if ('type' in instancia && instancia.type === 'node--instancia_letra') {
              list.push(processInstanciaLetra(instancia));
            }
          });
        }
        return list;
      });
  },
  saveImporteDatosEconomicos(importes) {
    return base.http().post(`${IMPORTES_URL}`, formatImportesDatosEconomicos(importes))
      .then(res => processImportesDatosEconomicos(res.data.data))
      .catch(error => this.catch404(error));
  },
  updateImporteDatosEconomicos(importes) {
    return base.http().patch(`${IMPORTES_URL}/${importes.id}`, formatImportesDatosEconomicos(importes))
      .then(res => processImportesDatosEconomicos(res.data.data))
      .catch(error => this.catch404(error));
  },
  saveGastosDatosEconomicos(gastos) {
    return base.http().post(`${GASTOS_URL}`, formatGastosDatosEconomicos(gastos))
      .then(res => processGastosDatosEconomicos(res.data.data))
      .catch(error => error);
  },
  updateGastosDatosEconomicos(gastos) {
    return base.http().patch(`${GASTOS_URL}/${gastos.id}`, formatGastosDatosEconomicos(gastos))
      .then(res => processGastosDatosEconomicos(res.data.data))
      .catch((error) => {
        throw error;
      });
  },
  createLetra(payload) {
    return base.post(`${LETRAS_URL}`, formatInstanciaLetra(payload))
      .then(res => processInstanciaLetraResponse(res));
  },
  updateLetra(payload) {
    return base.patch(`${LETRAS_URL}/${payload.id}`, formatInstanciaLetra(payload))
      .then(res => processInstanciaLetraResponse(res));
  },
  removeLetra(payload) {
    return base.delete(`${LETRAS_URL}/${payload.id}`);
  },
  catch404(error) {
    if (error.response && error.response.status === 404) {
      return [];
    }
    return error;
  },
};



// WEBPACK FOOTER //
// ./src/features/tab-datos-economicos/service.js